import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/messaging/constants';
import { messagingQueryKeys } from '@/modules/messaging/queries/queryKeys';
import type { MessageRequestApi } from '@/modules/messaging/types';
import { invalidateQuery } from '@/utils/queries';

interface SendMessageParams {
  threadId: string;
  message: MessageRequestApi;
}

export const useSendMessageMutation = () => {
  return useMutation({
    mutationFn: async ({ threadId, message }: SendMessageParams) => {
      const { data } = await fetchClient.POST(endpoints.threadMessages, {
        params: {
          path: {
            threadId,
          },
        },
        body: message,
      });

      return data;
    },
    onSettled: (_data, _error, variables) => {
      const { threadId } = variables;

      invalidateQuery(messagingQueryKeys.threads())();
      invalidateQuery(messagingQueryKeys.thread(threadId))();
    },
  });
};
